import React, { useEffect, useState } from 'react';

/**
 * FullscreenButton
 *
 * Sichtbarer, dezenter Vollbild-Umschalter oben rechts. Gedacht v. a. fürs
 * Offline-Bundle, das direkt im Präsentationsmodus startet (kein Dashboard).
 * Ein Klick = echtes Browser-Vollbild ohne Browser-Leiste (Fullscreen-API),
 * identisch zur Taste "F".
 */
export default function FullscreenButton() {
  const [isFs, setIsFs] = useState(false);

  useEffect(() => {
    const onChange = () => setIsFs(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onChange);
    document.addEventListener('webkitfullscreenchange', onChange);
    return () => {
      document.removeEventListener('fullscreenchange', onChange);
      document.removeEventListener('webkitfullscreenchange', onChange);
    };
  }, []);

  const toggle = () => {
    const el = document.documentElement;
    if (!document.fullscreenElement) {
      const req = el.requestFullscreen || el.webkitRequestFullscreen;
      req?.call(el)?.catch?.(() => {});
    } else {
      const exit = document.exitFullscreen || document.webkitExitFullscreen;
      exit?.call(document)?.catch?.(() => {});
    }
  };

  const label = isFs ? 'Vollbild beenden' : 'Vollbild';

  return (
    <button
      type="button"
      data-testid="fullscreen-toggle-btn"
      aria-label={label}
      title={`${label}  ·  F`}
      onClick={toggle}
      style={{
        position: 'fixed',
        top: 18,
        right: 18,
        zIndex: 101,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        padding: '8px 14px',
        borderRadius: 999,
        background: 'rgba(10, 10, 12, 0.55)',
        border: '1px solid rgba(212, 175, 55, 0.35)',
        color: 'rgba(255, 255, 255, 0.9)',
        fontFamily: '"Inter", ui-sans-serif, system-ui, -apple-system, sans-serif',
        fontSize: 12,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        cursor: 'pointer',
        opacity: 0.5,
        transition: 'opacity 300ms ease, background 300ms ease, border-color 300ms ease',
        userSelect: 'none',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.opacity = '1';
        e.currentTarget.style.background = 'rgba(20, 20, 22, 0.75)';
        e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.75)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.opacity = '0.5';
        e.currentTarget.style.background = 'rgba(10, 10, 12, 0.55)';
        e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.35)';
      }}
    >
      <svg
        width="13"
        height="13"
        viewBox="0 0 14 14"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {isFs ? (
          <>
            <path d="M5 1v4H1M13 5H9V1M9 13V9h4M1 9h4v4" />
          </>
        ) : (
          <>
            <path d="M1 5V1h4M13 5V1H9M9 13h4V9M5 13H1V9" />
          </>
        )}
      </svg>
      <span>{label}</span>
      <span
        style={{
          fontSize: 10,
          opacity: 0.55,
          border: '1px solid rgba(255,255,255,0.25)',
          borderRadius: 4,
          padding: '1px 5px',
          letterSpacing: '0.1em',
        }}
      >
        F
      </span>
    </button>
  );
}
